package chand.wordvoyage.data

import kotlinx.serialization.Serializable

@Serializable
data class DetailInfo(
    val meaning: String,
    val howToPronounce: String,
    val wordUsage: String,
    val examplesOfUsingWord: List<String>,
    val websiteLinkToStillMoreInfo: String
)

